import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import { level1Content } from '../../../styles/shareableStyles';

export const PreferencesSection = styled.div`
  padding: 16px;
  ${level1Content};
`;

export const PreferencesSectionTitle = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary900};
`;

export const PreferencesSectionDescription = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  max-width: 600px;
  color: ${theme.colors.secondary800};
`;

export const PreferencesSectionLink = styled(Link)`
  display: inline-block;
  margin-top: 10px;
  font-weight: 600;
  color: inherit;
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;

export const PreferencesContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  column-gap: 32px;
`;
